import React from "react";
import Button, { ButtonProps } from "./ui/button";

type Props = Omit<ButtonProps, "visualState" | "disabled">;

const FakeButton = React.forwardRef<HTMLButtonElement, Props>((props, ref) => {
  return (
    <Button ref={ref} visualState="fake" disabled type="button" {...props} />
  );
});

FakeButton.displayName = "FakeButton";

export default FakeButton;
